module.exports = __webpack_public_path__ + "41c4222a8426c3ef3aa33a1083f38e2c.svg";